window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// WorkSans 150
	this.text = new cjs.Text("Font", "150px 'Work Sans'", "#FFFFFF");
	this.text.lineHeight = 176;
	this.text.lineWidth = 486;
	this.text.parent = this;
	this.text.setTransform(83.8,59.55);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// WorkSans 90
	this.text_1 = new cjs.Text("Font", "90px 'Work Sans'", "#FFFFFF");
	this.text_1.lineHeight = 106;
	this.text_1.lineWidth = 275;
	this.text_1.parent = this;
	this.text_1.setTransform(90.3,75.8);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// WorkSans 60
	this.text_2 = new cjs.Text("Font", "60px 'Work Sans'", "#FFFFFF");
	this.text_2.lineHeight = 70;
	this.text_2.lineWidth = 275;
	this.text_2.parent = this;
	this.text_2.setTransform(93.5,83.9);
ranj.TextOffsetFixer.fix(this.text_2);

	this.timeline.addTween(cjs.Tween.get(this.text_2).wait(1));

	// WorkSans 30
	this.text_3 = new cjs.Text("Font", "30px 'Work Sans'", "#FFFFFF");
	this.text_3.lineHeight = 35;
	this.text_3.lineWidth = 87;
	this.text_3.parent = this;
	this.text_3.setTransform(96.8,91.95);
ranj.TextOffsetFixer.fix(this.text_3);

	this.timeline.addTween(cjs.Tween.get(this.text_3).wait(1));

	// WorkSans 22
	this.text_4 = new cjs.Text("Font", "22px 'Work Sans'", "#FFFFFF");
	this.text_4.lineHeight = 26;
	this.text_4.lineWidth = 87;
	this.text_4.parent = this;
	this.text_4.setTransform(97.55,94.05);
ranj.TextOffsetFixer.fix(this.text_4);

	this.timeline.addTween(cjs.Tween.get(this.text_4).wait(1));

	// WorkSans 18
	this.text_5 = new cjs.Text("Font", "18px 'Work Sans'", "#FFFFFF");
	this.text_5.lineHeight = 21;
	this.text_5.lineWidth = 87;
	this.text_5.parent = this;
	this.text_5.setTransform(98.1,95.2);
ranj.TextOffsetFixer.fix(this.text_5);

	this.timeline.addTween(cjs.Tween.get(this.text_5).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,44.9,1374.4,980.1), null);


// stage content:
(lib.TextPositioningAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(1041.8,597.6,-469.9,-101.60000000000002);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#999999",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.TextPositioningAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.TextPositioningAssets;